import { SECTION } from '~/consts';

export default {
  data() {
    return {
      loading_get_sections: false,
      loading_add_section: false,
    }
  },

  methods: {
    onGetSections(data) {
    },
    getSections(group_id) {
      const vm = this;

      vm.loading_get_sections = true;

      this.$axios.post(SECTION.GET_ALL(group_id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            this.onGetSections(data);
          } else {
            toast.danger(data.applicationSystem.message)
          }

          vm.loading_get_sections = false;
        }).catch(() => {
          vm.loading_get_sections = false;
        })
    },
    onSectionAdded() {},
    onSectionFailAdd() {},
    async addSection(group_id, section) {
      const vm = this;

      vm.loading_add_section = true;

      try {
        let { data } = await this.$axios.post(SECTION.ADD(group_id), {
          started_at: !this.isEmpty(section.startedAt) ? section.startedAt : null,
          ended_at: !this.isEmpty(section.endedAt) ? section.endedAt : null,
          meet: !this.isEmpty(section.meet) ? section.meet : null,
          room: !this.isEmpty(section.room) ? section.room : null,
          topic: !this.isEmpty(section.topic) ? section.topic : null
        });

        if (data.applicationSystem.code == 0) {
          this.onSectionAdded(data);
          return data.data;
        } else {
          toast.danger(data.applicationSystem.message);
          throw new Error;
        }

        vm.loading_add_section = false;
      } catch (e) {
        vm.loading_add_section = false;
        this.onSectionFailAdd();
        return null;
      }
    },
    async updateSection(section) {
      const vm = this;

      vm.loading_add_section = true;

      try {
        let { data } = await this.$axios.post(SECTION.UPDATE(section.id,), {
          started_at: !this.isEmpty(section.startedAt) ? section.startedAt : null,
          ended_at: !this.isEmpty(section.endedAt) ? section.endedAt : null,
          meet: !this.isEmpty(section.meet) ? section.meet : null,
          room: !this.isEmpty(section.room) ? section.room : null,
          topic: !this.isEmpty(section.topic) ? section.topic : null
        });

        if (data.applicationSystem.code == 0) {
          vm.loading_add_section = false;
          return data.data;
        } else {
          toast.danger(data.applicationSystem.message);
          throw new Error;
        }
      } catch (e) {
        vm.loading_add_section = false;
        return null;
      }
    },
    onSectionCopiedSuccess() {},
    onSectionCopiedFailed(data = null) {
      if (!this.isEmpty(data)) {
        this.$buefy.toast.open({
          message: data.applicationSystem.message,
          type: 'is-danger'
        })
      }
    },
    copySection(id, class_ids) {
      const vm = this

      this.$axios.post(SECTION.DUPLICATE(id), {
        class_ids
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onSectionCopiedSuccess(data)
          } else {
            vm.onSectionCopiedFailed(data)
          }
        })
        .catch(() => {
          vm.onSectionCopiedFailed()
        })
    }
  }
}
